<div class="col-12 p-3 p-lg-0 container-form-modal-pages">
    <div class="d-flex flex-column justify-content-center align-items-center">
        <p class="design-modal-title" *ngIf="!data.isFile">
            {{ 'app.global.modals.image_manager.used-images-modal.title' | translate }}
        </p>
        <p class="design-modal-title" *ngIf="data.isFile">
            {{ 'app.global.modals.image_manager.used-images-modal.title-file' | translate }}
        </p>
    </div>
    <div class="no-gutters warning-container">
        <mat-list>
            <ng-container *ngFor="let warning of data.warnings">
                <p class="design-modal-title">
                    <i class="fa-light fa-image mr-2"></i>
                    <i>{{ warning.name }}</i>
                </p>
                <ul *ngFor="let module of warning.modules">
                    <li>
                        <i>{{ module }}</i>
                    </li>
                </ul>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-list>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-start mt-3">
        <p class="design-modal-title">
            {{ 'app.global.modals.image_manager.used-images-modal.subtitle' | translate }}
        </p>
    </div>
    <div class="d-flex justify-content-between justify-content-sm-end mt-3 mt-lg-4">
        <button class="btn btn-skip mr-0 mr-sm-4" (click)="closeDialog()">
            {{ 'app.global.modals.image_manager.used-images-modal.buttons.cancel' | translate }}
        </button>
        <button class="btn btn-continue" (click)="closeDialog(true)">
            {{ 'app.global.modals.image_manager.used-images-modal.buttons.accept' | translate }}
        </button>
    </div>
</div>
